import React from 'react';
import PropTypes from 'prop-types';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function UserActions(props) {
  const { onClickDelete } = props;
  const { auth, users } = props;

  if (!users.user || +auth.user.userid === +users.user.user_id) {
    return [];
  }

  return (
    <div
      data-test="role-action"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTipIcon toolText="Delete User">
        <button
          type="button"
          onClick={onClickDelete}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/delete_button.svg"
            alt="Delete"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>
    </div>
  );
}

UserActions.propTypes = {
  onClickDelete: PropTypes.func,
  auth: PropTypes.object.isRequired,
  users: PropTypes.object.isRequired,
};

export default UserActions;
